class CollapsibleSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupAccordion();
  }

  setupAccordion() {
    const collapsibleItems = this.querySelectorAll('.collapsible-item');

    collapsibleItems.forEach((item) => {
      const summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          // Prevent the default toggle behavior
          event.preventDefault();

          // Check if this item is currently open
          const isCurrentlyOpen = item.hasAttribute('open');

          // Close all other collapsibles
          this.closeAllCollapsibles();

          // If this item wasn't open, open it
          if (!isCurrentlyOpen) {
            item.setAttribute('open', '');
          }
        });
      }
    });
  }

  closeAllCollapsibles() {
    const collapsibleItems = this.querySelectorAll('.collapsible-item');
    collapsibleItems.forEach((item) => {
      item.removeAttribute('open');
    });
  }
}

customElements.define('collapsible-section', CollapsibleSection);
